import { fetchCategoryChildrenList } from "@/src/redux/actions/baseDataActions";
import type { AppDispatch, RootState } from "@/src/redux/types";
import type { CategoryChild } from "@/src/types/category.types";

export type RefreshCategoryChildrenOptions = {
  force?: boolean;
};

let inFlightRefresh: Promise<CategoryChild[]> | null = null;

export async function refreshCategoryChildren(
  dispatch: AppDispatch,
  getState: () => RootState,
  options: RefreshCategoryChildrenOptions = {},
): Promise<CategoryChild[]> {
  const state = getState();
  const userId = state.auth.user?.id ?? null;
  const { categoryChildren, fetchedForUserId, loading } = state.baseData;

  if (
    !options.force &&
    !loading &&
    userId &&
    fetchedForUserId === userId &&
    categoryChildren.length > 0
  ) {
    return categoryChildren;
  }

  if (inFlightRefresh) {
    return inFlightRefresh;
  }

  inFlightRefresh = dispatch(fetchCategoryChildrenList())
    .unwrap()
    .then((result) => result.categoryChildren)
    .finally(() => {
      inFlightRefresh = null;
    });

  return inFlightRefresh;
}
